// Imports
import React, { useRef, useEffect } from "react";
import FocusTrap from "focus-trap-react";
import closeCross from "src/files/cross.svg";

// eslint-disable-next-line react/prop-types
function RecModal({ children, title, desc, modalRef, onClose }) {
  const dialogRef = useRef(null);

  useEffect(() => {
    const dialog = dialogRef.current;
    if (dialog) {
      dialog.showModal();
    }

    return () => {
      if (dialog) {
        dialog.close();
      }
    };
  }, []);

  return (
    <FocusTrap>
      <dialog className="rec-modal" ref={dialogRef}>
        <div className="rec-modal__container" ref={modalRef}>
          {onClose && (
            <button className="rec-modal__close-button" onClick={onClose}>
              <img className="rec-modal__icon-cross" src={closeCross} alt="" />
            </button>
          )}
          {title && <h2 className="rec-modal__title">{title}</h2>}
          {desc && <p className="rec-modal__desc">{desc}</p>}
          {children}
        </div>
      </dialog>
    </FocusTrap>
  );
}

export default RecModal;
